import api from './api';

const authService = {
  /**
   * Login partner user
   * Usa el endpoint específico de partners: /v1/partners/auth/login
   */
  async login(email, password) {
    const response = await api.post('/partners/auth/login', { email, password });
    return response.data;
  },

  /**
   * Logout partner user
   */
  async logout() {
    try {
      // Partners no tiene endpoint de logout específico, solo limpiar localStorage
    } catch (error) {
      // Ignore logout errors
    }
    localStorage.removeItem('partnerToken');
    localStorage.removeItem('partnerUser');
  },

  /**
   * Request password reset
   */
  async forgotPassword(email) {
    const response = await api.post('/auth/forgot-password', { email });
    return response.data;
  },

  /**
   * Reset password with token
   */
  async resetPassword(token, newPassword) {
    const response = await api.post('/auth/reset-password', { token, newPassword });
    return response.data;
  },

  /**
   * Get current user profile
   * Usa el endpoint específico de partners: /v1/partners/auth/me
   */
  async getProfile() {
    const response = await api.get('/partners/auth/me');
    return response.data;
  },

  /**
   * Update user profile
   */
  async updateProfile(data) {
    const response = await api.put('/partners/profile', data);
    return response.data;
  },

  /**
   * Change password
   * Usa el endpoint específico de partners: /v1/partners/auth/change-password
   */
  async changePassword(currentPassword, newPassword) {
    const response = await api.post('/partners/auth/change-password', {
      currentPassword,
      newPassword
    });
    return response.data;
  },

  /**
   * Refresh token
   * Usa el endpoint específico de partners: /v1/partners/auth/refresh
   */
  async refreshToken(refreshToken) {
    const response = await api.post('/partners/auth/refresh', { refreshToken });
    return response.data;
  },

  /**
   * Validate stored token (usando el endpoint /auth/me de partners)
   */
  async validateToken() {
    const token = localStorage.getItem('partnerToken');
    if (!token) return null;

    try {
      const response = await api.get('/partners/auth/me');
      return response.data;
    } catch (error) {
      localStorage.removeItem('partnerToken');
      localStorage.removeItem('partnerUser');
      return null;
    }
  }
};

export default authService;
